function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import queryString from 'query-string';
export var DomainCheckerService = /*#__PURE__*/function () {
  function DomainCheckerService(httpClient) {
    this._httpClient = httpClient;
  }

  var _proto = DomainCheckerService.prototype;

  _proto.get = function get(url, options) {
    return this._httpClient.get(url, options).then(function (_ref) {
      var data = _ref.data;
      return data;
    });
  };

  _proto.checkDomainAvailabilityV2 = function checkDomainAvailabilityV2(strDomain, isParsed) {
    if (strDomain === void 0) {
      strDomain = '';
    }

    if (isParsed === void 0) {
      isParsed = false;
    }

    if (!strDomain) {
      throw new Error("DomainCheckerService - checkDomainAvailabilityV2 - domain", strDomain);
    }

    var returnPromise = Promise.resolve(null);
    var domain = isParsed ? strDomain : strDomain.replace(/[^a-zA-Z0-9-]/g, '').toLowerCase() + ".com";

    if (domain) {
      returnPromise = this.get("/v1/domain-search/checkAvailability", {
        params: {
          domain: domain
        }
      }).then(function (data) {
        return _objectSpread(_objectSpread({}, data), {}, {
          domain: domain
        });
      });
    }

    return returnPromise;
  };

  _proto.getDomainSuggestionsByBusinessName = function getDomainSuggestionsByBusinessName(businessName, options) {
    if (options === void 0) {
      options = {};
    }

    var _options = options,
        _options$tlds = _options.tlds,
        tlds = _options$tlds === void 0 ? ['com', 'net'] : _options$tlds,
        _options$maxResults = _options.maxResults,
        maxResults = _options$maxResults === void 0 ? 10 : _options$maxResults,
        _options$useDashes = _options.useDashes,
        useDashes = _options$useDashes === void 0 ? true : _options$useDashes,
        _options$maxLength = _options.maxLength,
        maxLength = _options$maxLength === void 0 ? 50 : _options$maxLength;
    var params = queryString.stringify({
      businessName: businessName,
      tlds: tlds,
      maxResults: maxResults,
      useDashes: useDashes,
      maxLength: maxLength
    });
    return this.get("/v1/domain-search/suggestDomain?" + params);
  };

  return DomainCheckerService;
}();